import { Button } from 'primereact/button'

export function SeeMoreButton(props: { label: string; action: () => void }) {
  return (
    <Button
      rounded
      text
      icon='pi pi-angle-right'
      iconPos='right'
      label={props.label}
      className='my-5 p-0'
      onClick={props.action}
    ></Button>
  )
}
